import type { ConsultantGrade } from '@/api/types/calibrationMatrix.types';

export const GRADE_OPTIONS: ConsultantGrade[] = ['AC', 'C', 'M', 'AP'];

export const ANALYTICS_VALUE = 'Analytics';
export const B2B_SERVICES_VALUE = 'B2B Services';
export const FMCG_VALUE = 'FMCG';
export const GENERALIST_VALUE = 'Generalist';
export const RETAIL_AND_LEISURE_VALUE = 'Retail & Leisure';
export const TMT_VALUE = 'TMT';

// Staff departments span the whole company (HR, PAs and EAs, Commercial Operations
// and Staffing, ...); only these ones belong to the consulting team.
export const CONSULTING_SECTORS: string[] = [
  ANALYTICS_VALUE,
  B2B_SERVICES_VALUE,
  FMCG_VALUE,
  GENERALIST_VALUE,
  RETAIL_AND_LEISURE_VALUE,
  TMT_VALUE,
];
